import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from '@perval/shared';
import { CognitoService } from '../../authentification/services/cognito/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class IsNotAuthdGuard implements CanActivate {
  constructor(private cognitoService: CognitoService) {}

  async canActivate(): Promise<boolean> {
    const isAuthenticated: boolean = await this.cognitoService.isAuthenticated();
    if (isAuthenticated) {
      window.location.href = `${environment.host}/content/accueil`;
      return false;
    }

    return !isAuthenticated;
  }
}
